(function(angular) {
    "use strict";
    var fmgCommon = angular.module("common-services");

    fmgCommon.directive("fmgLogi", function() {
        return {
            restrict: "E",
            scope: {
                __reportName: "=reportName",
                __parameters: "=parameters",
                __reportId: "=reportId",
                env: "=?",
                refresh: "=",
                autoLoad: "=",
                renderCompleted: "="
            },
            controller: [
                "$scope",
                "app_env",
                "$interval",
                function($scope, app_env, $interval) {
                    if (!$scope.env) {
                        $scope.env = "reportsUrl";
                    }

                    $scope.$watch("__reportName", function(newValue) {
                        $scope.refresh();
                    });

                    var report;
                    $scope.refresh = function() {
                        if (!$scope.__reportName) {
                            return;
                        }

                        var options = {
                            applicationUrl: app_env[$scope.env],
                            report: $scope.__reportName,
                            autoSizing: "all",
                            secureKey: "",
                            linkParams: $scope.__parameters
                        };

                        console.log("Loading Report " + $scope.__reportName, $scope.__parameters);
                        if (report != null) {
                            EmbeddedReporting.remove($scope.__reportId);
                        }

                        $scope.isLoading = true;
                        report = EmbeddedReporting.create($scope.__reportId, options);

                        var originalMethod = report.frameLoaded;

                        //Wrap frameLoaded so we can be notified when the frame has finished loading
                        report.frameLoaded = function() {
                            if ($scope.renderCompleted) {
                                $scope.renderCompleted();
                            }

                            //This is a nasty hack because Logi is blocking the digest cycle doing a sync XHR
                            $scope.$apply(function() {
                                $scope.isLoading = false;
                            });
                            originalMethod.call(report); //Use .call(report) syntax as EmbeddedReporting object does not play nice and assumes what 'this' means
                        };
                    };

                    if ($scope.autoLoad === true) {
                        var autoLoadInterval = $interval(function() {
                            //Does Id Exist
                            var target = document.getElementById($scope.__reportId);

                            //Yes - render Report, & kill interval

                            if (target) {
                                $scope.stopInterval();
                                $scope.refresh();
                            }
                        }, 1 * 1000);
                    }

                    $scope.$on("$destroy", function() {
                        $scope.stopInterval();

                        //Clean Up report
                        if (report) {
                            EmbeddedReporting.remove($scope.__reportId);
                        }
                    });

                    $scope.stopInterval = function() {
                        if (angular.isDefined(autoLoadInterval)) {
                            $interval.cancel(autoLoadInterval);
                            autoLoadInterval = undefined;
                        }
                    };
                }
            ],
            template: '<md-progress-linear md-mode="indeterminate" ng-if="isLoading"></md-progress-linear><div id="{{__reportId}}"></div>'
        };
    });
})(window.angular);
